'use client';

import React from 'react';
import { MessageSquare } from 'lucide-react';

interface ProjectDetailsProps {
  message: string;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

const ProjectDetails: React.FC<ProjectDetailsProps> = ({
  message,
  handleInputChange
}) => {
  return (
    <div className="relative">
      <MessageSquare className="absolute left-4 top-4 w-5 h-5 text-gray-400" />
      <textarea
        name="message"
        placeholder="Project details (optional)"
        value={message}
        onChange={handleInputChange}
        rows={3}
        className="w-full pl-12 pr-4 py-4 rounded-lg border-2 border-gray-300 focus:ring-2 focus:ring-green-500/20 focus:border-green-500 text-gray-900 placeholder-gray-400 text-base font-medium resize-none transition-all duration-300 bg-white"
        suppressHydrationWarning={true}
      />
    </div>
  );
};

export default ProjectDetails;